import { deleteCookie, getCookie, setCookie } from './cookies';

// Shared constants for store ID storage
export const STORE_ID_STORAGE_KEY = 'dank_store_id';

// Helper functions for store ID storage
export function getStoredStoreId(): number | null {
  if (typeof window === 'undefined') return null;
  try {
    const storedCookie = getCookie(STORE_ID_STORAGE_KEY);
    const stored =
      storedCookie ||
      (typeof localStorage !== 'undefined'
        ? localStorage.getItem(STORE_ID_STORAGE_KEY)
        : null);
    if (stored) {
      const storeId = parseInt(stored, 10);
      if (Number.isFinite(storeId) && storeId > 0) {
        // One-time migration: if it only existed in localStorage, move it to cookie
        if (!storedCookie) {
          setCookie(STORE_ID_STORAGE_KEY, String(storeId), { maxAgeDays: 30 });
          try {
            localStorage.removeItem(STORE_ID_STORAGE_KEY);
          } catch {}
        }
        return storeId;
      }
    }
  } catch (err) {
    console.error('[store-storage] Failed to get stored store ID:', err);
  }
  return null;
}

export function setStoredStoreId(storeId: number): void {
  if (typeof window === 'undefined') return;
  try {
    setCookie(STORE_ID_STORAGE_KEY, String(storeId), { maxAgeDays: 30 });
    // Cleanup old storage (if present)
    try {
      localStorage.removeItem(STORE_ID_STORAGE_KEY);
    } catch {}
  } catch (err) {
    console.error('[store-storage] Failed to save store ID:', err);
  }
}

export function clearStoredStoreId(): void {
  if (typeof window === 'undefined') return;
  try {
    deleteCookie(STORE_ID_STORAGE_KEY);
    // Cleanup old storage (if present)
    try {
      localStorage.removeItem(STORE_ID_STORAGE_KEY);
    } catch {}
  } catch (err) {
    console.error('[store-storage] Failed to clear store ID:', err);
  }
}

